export default (
    <svg viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.91406 3.82444V20.9351C6.91406 21.6915 7.21452 22.4168 7.74933 22.9517C8.28414 23.4865 9.00951 23.7869 9.76585 23.7869H21.173C21.9293 23.7869 22.6547 23.4865 23.1895 22.9517C23.7243 22.4168 24.0248 21.6915 24.0248 20.9351V8.44718C24.0247 8.06727 23.9488 7.69119 23.8014 7.34104C23.654 6.99089 23.4381 6.67372 23.1664 6.40816L18.4395 1.78541C17.9068 1.26448 17.1913 0.972749 16.4462 0.972656H9.76585C9.00951 0.972656 8.28414 1.27311 7.74933 1.80792C7.21452 2.34274 6.91406 3.0681 6.91406 3.82444Z"
            stroke="white"
            strokeWidth="1.58432"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.3212 23.7869V26.6386C18.3212 27.395 18.0207 28.1203 17.4859 28.6552C16.9511 29.19 16.2257 29.4904 15.4694 29.4904H4.06223C3.30589 29.4904 2.58053 29.19 2.04572 28.6552C1.5109 28.1203 1.21045 27.395 1.21045 26.6386V10.9538C1.21045 10.1975 1.5109 9.47213 2.04572 8.93732C2.58053 8.40251 3.30589 8.10205 4.06223 8.10205H6.91402"
            stroke="white"
            strokeWidth="1.58432"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
